import { empApi } from "./client";

// =============================================================
// Danh mục dùng cho "Bộ lọc chi tiết" của các màn Quản lý.
// Khớp endpoint app (register-employee / attendance-management):
//   saleArea | saleBlock | supportDepartment | branch
// Hỗ trợ phân trang + tìm kiếm giống bottom sheet của app.
// =============================================================

export const getSaleAreaOptionsApi = (params) => empApi.get("/saleArea", params);

export const getSaleBlockOptionsApi = (params) => empApi.get("/saleBlock", params);

export const getSupportDepartmentOptionsApi = (params) =>
  empApi.get("/supportDepartment", params);

export const getBranchOptionsApi = (params) => empApi.get("/branch", params);

export const getProjectOptionsApi = (params) => empApi.get("/project/app", params);

export const getAgentOptionsApi = (params) => empApi.get("/agent", params);

// Chuẩn hoá response về mảng items (BE trả nhiều dạng khác nhau).
export const normalizeOptionItems = (res) => {
  const items =
    res?.items ?? res?.data?.items ?? res?.docs ?? res?.results ?? res?.data ?? res ?? [];
  return Array.isArray(items) ? items : [];
};

export const normalizeHasNextPage = (res, fallback = false) =>
  Boolean(res?.pagination?.hasNextPage ?? res?.data?.pagination?.hasNextPage ?? fallback);
